<template>
  <div v-if="channelInfo">
    <!-- 레이어 팝업 -->

    <PopupShare
      v-if="shareLayout"
      :id="`live_channel_${channelId}`"
      :title="channelInfo.channelname"
      :description="channelInfo.title"
      :image="channelInfo.image"
      @on-click-close="closeShareLayout"
    />
    <template v-if="!isFirstLoading">
      <main id="contents" class="live player-wrap">
        <!-- 플레이어 -->
        <LivePlayer
          v-if="get(channelInfo, 'channelid', '') !== ''"
          key="liveplayer"
          :channel-info="channelInfo"
          :data-home-shopping="dataHomeShopping"
          :data-home-shopping-add-info="dataHomeShoppingAddInfo"
          :channel-id="get(channelInfo, 'channelid', '')"
          :open-share-popup="openShareLayout"
        />

        <!-- 홈쇼핑 추가 정보 영역 -->
        <div
          v-if="
            dataHomeShoppingAddInfo &&
            get(dataHomeShoppingAddInfo, 'imagelist', []).length !== 0 &&
            dataHomeShopping
          "
        >
          <div class="player-nav">
            <ul>
              <li>
                <button type="button">상품정보</button>
              </li>
            </ul>
            <button type="button" class="reload" @click.prevent="reload()">
              새로고침
            </button>
          </div>
          <div id="product" class="live-product">
            <div class="lp-img" :style="homeshoppingImageStyle">
              <a
                :href="'http://' + dataHomeShopping.orderurl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  :src="
                    getImage(dataHomeShoppingAddInfo.imagelist[0].shoppingimage)
                  "
                  alt="상품정보"
                />
              </a>
            </div>
          </div>
        </div>

        <template v-if="!isLoading && channelInfo.homeshopping === 'y'">
          <HomeShoppingList
            v-if="hasHomeShoppingAddInfo"
            :data-list="dataHomeShoppingAddInfo.list"
          />
        </template>

        <!-- 탭 -->
        <div class="player-nav">
          <ul>
            <li>
              <button
                type="button"
                :class="currentTabIs('all') ? 'on' : ''"
                @click.prevent="changeTab('all')"
              >
                전체 채널
              </button>
            </li>
            <li>
              <button
                type="button"
                :class="currentTabIs('recommend') ? 'on' : ''"
                @click.prevent="changeTab('recommend')"
              >
                추천
              </button>
            </li>
          </ul>
          <button type="button" class="reload" @click.prevent="reload()">
            새로고침
          </button>
        </div>
        <template v-if="currentTabIs('all')">
          <LiveAllList />
        </template>
        <template v-if="currentTabIs('recommend')">
          <LiveMultiSection
            :channel-info="channelInfo"
            :channel-id="channelId"
          />
        </template>
      </main>
      <MetaInfo :content-info="channelInfo" content-type="live" />
    </template>
    <div v-else class="min-h-screen" />
  </div>
</template>

<script>
  import _ from 'lodash'
  import streamPageMixin from '@/mixins/stream.page.mixin'
  import playerPage from '@/mixins/player.page.mixin'
  import LivePlayer from '@/components/player/LivePlayer'
  import HomeShoppingList from '@/components/live/HomeShoppingList'
  import {
    getLiveChannelsDetail,
    getHomeShopping,
    getHomeShoppingAddinfo,
  } from '@/common/utils/request'
  import { url } from '@/common/filters/url.filter'
  import cookie from '@/common/utils/cookie'
  import {
    showLoginPopup,
    setPlayerModeDefault,
    showVoucherPopup,
  } from '@/common/utils/scalable.player'
  import LiveAllList from '@/components/player/LiveAllList'
  import LiveMultiSection from '@/components/live/LiveMultiSection'
  import {
    contentDetailErrorCatcher,
    destroyPlayer,
    getContentDetailData,
    scrollTopWithCallback,
    sleep,
  } from '@/common/utils/common'
  import {
    checkAdultContent,
    openAdultPopupIfNeeded,
  } from '@/common/utils/adult'
  import {
    LOGIN_SUCCESS_EVENT,
    SET_CURRENT_MENU,
    UPDATE_CONTENT_INFO_EVENT,
  } from '@/common/resources/const'
  import { mapMutations } from 'vuex'
  import { parseUrl } from 'query-string'
  import MetaInfo from '@/components/meta/Meta'
  import { setReferer } from '@/common/utils/referer'
  import { multiProfileAutoLogin, autoLoginSetting } from '@/common/utils/login'
  import { resizeThumbnail } from '@/common/utils/image'
  import PopupShare from '@/components/player/PopupShare.vue'
  import braze from '@/common/utils/braze'
  import { getPurchaseProperties } from '@/common/utils/braze.util'

  export default {
    components: {
      PopupShare,
      LiveAllList,
      LivePlayer,
      HomeShoppingList,
      LiveMultiSection,
      MetaInfo,
    },
    filters: {
      url,
    },
    mixins: [playerPage, streamPageMixin],
    data() {
      return {
        isLoading: true,
        isFirstLoading: true,
        isVisibleVodButton: false,
        type: 'live',
        tabType: 'all',
        isLogin: cookie.isCsInfo(),
        channelId: '',
        channelInfo: {},
        hasHomeShoppingAddInfo: false,
        dataHomeShopping: {}, // 홈쇼핑 데이터  홈쇼핑은 여러군데서 사용해서 여기서 부르는게 맞음
        dataHomeShoppingAddInfo: {}, // 홈쇼핑 추가 데이터
        homeshoppingImageStyle: '',
        offset: 0,
        limit: 20,
        liveMenuData: [],
        maxPage: 5,
        dataPerPage: 6,
        channelInfoUpdateTimer: null,
        channelInfoUpdateTimerSeconds: 1000 * 60 * 5,
      }
    },

    methods: {
      get: _.get,
      getImage(url) {
        return resizeThumbnail(url, {
          width: 0,
          height: 0,
          option: 20,
          quality: 80,
        })
      },
      ...mapMutations([SET_CURRENT_MENU]),
      currentTabIs(tabType) {
        return this.tabType === tabType
      },
      changeTab(tabType) {
        this.tabType = tabType
      },
      async checkAdultLiveContent() {
        this.isFirstLoading = true
        try {
          const { data } = await getLiveChannelsDetail({
            channelid: this.channelId,
          })
          const { isAdultVerified } = await checkAdultContent(data)
          await openAdultPopupIfNeeded({ isAdultVerified })
          this.isFirstLoading = !isAdultVerified
        } catch (e) {
          console.error(e)
        }
      },
      async getLiveData() {
        this.isLoading = true
        const getData = getContentDetailData.bind(this)
        const errorCatcher = contentDetailErrorCatcher.bind(this)
        this.channelInfo = await getLiveChannelsDetail({
          channelid: this.channelId,
        })
          .then(getData)
          .catch(errorCatcher)
        if (Number(this.channelInfo?.targetage) < 19)
          setReferer(this.$route.fullPath ?? '/')
        const hasHomeShopping =
          _.get(this.channelInfo, 'homeshopping', 'n') === 'y'

        // todo: device=pc 에서 ispreorder 무조건 'n' 으로 내려옴 -> 로직 제거 필요 (23-05-17)
        this.hasHomeShoppingAddInfo =
          _.get(this.channelInfo, 'ispreorder', 'n') === 'y'
        if (hasHomeShopping) {
          this.dataHomeShopping = await getHomeShopping({
            channelid: this.channelId,
          })
            .then(getData)
            .catch(errorCatcher)
        }
        if (this.hasHomeShoppingAddInfo) {
          this.dataHomeShoppingAddInfo = await getHomeShoppingAddinfo({
            channelid: this.channelId,
          }).catch(errorCatcher)
        }

        this.isLoading = false
        this.setPlayerEvent()
      },
      reload() {
        this.$events.$emit('reload')
      },
      // pooq 플레이어에서 쓰는 이벤트 설정
      setPlayerEvent() {
        window.showLoginLayout = showLoginPopup
        window.showVoucherPopup = showVoucherPopup // 이용권 팝업
        window.showEventVoucherPopup = () => {
          window.open(
            '/voucher/popup?type=all',
            '',
            'width=700, height=780, scrollbars=yes',
          )
        } // 이벤트 이용권 팝업
      },
      initialize() {
        scrollTopWithCallback(setPlayerModeDefault)
        const { query } = parseUrl(location.href)
        this[SET_CURRENT_MENU](this.type)
        this.channelId = _.get(query, 'channelid', '')
        this.dataHomeShopping = {}
        this.dataHomeShoppingAddInfo = {}
      },
      updateContentInfo(info) {
        this.channelId = _.get(info, 'contentID', '')
        this.setPlayerEvent()
        this.replaceState(`/player/live?channelid=${this.channelId}`)
      },
      async postMessage(e) {
        if (e.origin === location.origin) {
          const eventMessage = _.get(e, 'data.eventMessage', e.data)
          if (eventMessage === 'voucherAutoLogin') {
            const credential = cookie.getCredential()
            const isMultiLine = Number(cookie.userInfo('profilecount')) !== 1
            autoLoginSetting(credential, isMultiLine).then(() => {
              location.reload()
            })
          }
          if (eventMessage === 'purchaseComplete') {
            if (e.data?.params?.result === 'y') {
              braze.purchase(getPurchaseProperties(e.data.params))
            }
            await multiProfileAutoLogin()
            await sleep(1000)
            location.reload()
          }
        }
      },
    },
    watch: {
      $route(n, o) {
        const newChannelId = _.get(n, ['query', 'channelid'], '')
        const oldChannelId = _.get(o, ['query', 'channelid'], '')
        if (newChannelId !== oldChannelId) {
          this.initialize()
          this.checkAdultLiveContent()
          this.getLiveData()
          this.setPlayerEvent()
        }
      },
    },
    created() {
      window.addEventListener('message', this.postMessage)
      this.initialize()
      this.checkAdultLiveContent()
      this.getLiveData()
      this.setPlayerEvent()
    },
    mounted() {
      // destroyPlayer()
      this.$events.$on(UPDATE_CONTENT_INFO_EVENT, (value) => {
        this.updateContentInfo(value)
      })
      this.$events.$on(LOGIN_SUCCESS_EVENT, () => {
        location.reload()
      })
      this.channelInfoUpdateTimer = setInterval(
        this.getLiveData,
        this.channelInfoUpdateTimerSeconds,
      )
    },
    beforeDestroy() {
      this.$events.$off(UPDATE_CONTENT_INFO_EVENT)
      this.$events.$off(LOGIN_SUCCESS_EVENT)
      destroyPlayer()
      clearInterval(this.channelInfoUpdateTimer)
      window.removeEventListener('message', this.postMessage)
    },
  }
</script>

<style lang="scss" src="@/assets/scss/category/live.scss"></style>
<style lang="css">
  .player-wrap .multi-live {
    margin-top: 40px;
  }
</style>
